import React from "react";
import styled from "styled-components";
import backgroundImg from "assets/images/whitepapers-bg.png";
import splashBg1 from "assets/images/splash-bg1_alternate.png";
import splashBg2 from "assets/images/splash-bg2_alternate.png";

const Root = styled.div`
  background-image: url(${props => props.bg});
  background-size: cover;
  background-position: center;
  position: relative;
`;

const Container = styled.div`
  height: 85rem;
  position: relative;
`;

const Content = styled.div`
  color: ${props => props.theme.colors.primary.white};
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  .title {
    font-size: 3.6rem;
    font-weight: ${props => props.theme.fontWeight.black};
    text-transform: uppercase;
  }
`;

const BackBg1 = styled.img`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 20rem;
  z-index: 0;
  opacity: .5;
  mix-blend-mode: hard-light;
`;

const BackBg2 = styled.img`
  position: absolute;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 20rem;
  z-index: 0;
  opacity: .5;
  mix-blend-mode: hard-light;
`;

const Background = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const Filter = styled.div`
  width: 100%;
  height: 100%;
  background: #212020 0% 0% no-repeat padding-box;
  mix-blend-mode: hard-light;
  opacity: 0.8;
  position: absolute;
`;

export const ResearchSplash = () => {
  return (
      <Root>
        <Background>
          <img src={backgroundImg} alt="" />
        </Background>
        <Filter />
        <BackBg1 src={splashBg1} />
        <BackBg2 src={splashBg2} />
        <Container className="container">
          <Content>
            <div className="title">Research</div>
          </Content>
        </Container>
      </Root>
  );
};
